const ROOT_STYLES_ID = 'chatty-root-styles';
/**
 * Simple CSS root styles updater
 */
class StylesUpdater {
  constructor() {
    this.queue = [];
    this.processing = false;
  }

  update(rules) {
    this.queue.push(rules);
    if (!this.processing) this.process();
  }

  async process() {
    if (this.processing) return;
    this.processing = true;

    try {
      // Merge all queued updates
      const merged = {};
      while (this.queue.length) {
        Object.assign(merged, this.queue.shift());
      }

      // Get current rules from DOM
      const current = this.getCurrentRules();

      // Apply updates
      Object.entries(merged).forEach(([prop, value]) => {
        if (value == null) {
          current.delete(prop);
        } else {
          current.set(prop, value);
        }
      });

      // Update DOM
      this.applyToDom(current);
    } finally {
      this.processing = false;
      if (this.queue.length) queueMicrotask(() => this.process());
    }
  }

  getCurrentRules() {
    const el = document.getElementById(ROOT_STYLES_ID);
    if (!el) return new Map();

    const rules = new Map();
    const match = el.textContent.match(/:root\s*\{([^}]*)\}/);
    if (match) {
      match[1].split(';').forEach(rule => {
        const [prop, value] = rule.split(':');
        if (prop?.trim() && value?.trim()) {
          rules.set(prop.trim(), value.trim());
        }
      });
    }
    return rules;
  }

  applyToDom(rules) {
    let el = document.getElementById(ROOT_STYLES_ID);
    if (!el) {
      el = document.createElement('style');
      el.id = ROOT_STYLES_ID;
      document.head.appendChild(el);
    }

    if (rules.size === 0) {
      el.textContent = '';
      return;
    }

    const css = Array.from(rules, ([prop, value]) => `${prop}: ${value}`).join('; ');
    el.textContent = `:root { ${css} }`;
  }
}

const updater = new StylesUpdater();

export default function updateRootStyles(rules) {
  updater.update(rules);
}
